module.exports = __webpack_public_path__ + "img/lv13.44322469.png";